import React from 'react';
import './VideoConsentLayer.scss';
import * as Klaro from 'klaro';
import getKlaroConfig from '../../../config/klaro';
import { useTranslation } from '../../../config/TranslationProvider';

const VideoConsentLayer = ({provider, setShowVideoConsentLayer, setShowModal}) => {
    const capitalizedProvider = provider.charAt(0).toUpperCase() + provider.slice(1);

    const changeConsent = () => {
        const consentManager = Klaro.getManager(getKlaroConfig());
        consentManager.updateConsent(provider, true);
        consentManager.saveAndApplyConsents();

        setShowVideoConsentLayer(false);
        setShowModal(true);
    };

    return (
        <div className="video-consent-modal">
            <div className="video-consent-dialog">
                <p style={{ color: '#3a3a3a', textAlign: 'center' }}>
                    {useTranslation('video_consent_dialog', {videoProvider: capitalizedProvider})}
                </p>
                <div className="button-container">
                    <span className="button" role="button" onClick={changeConsent}>
                        {useTranslation('yes')}
                    </span>
                    <span className="button" role="button" onClick={() => setShowVideoConsentLayer(false)}>
                        {useTranslation('no')}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default VideoConsentLayer;